import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REGISTER,
  AUTH_ERROR,
  AUTH_LOADING,
  AUTH_RESET_PASSWORD,
  AUTH_CONNECT_FACEBOOK,
  AUTH_CONNECT_LINE
} from './actions';

// Initial state
const initialState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  facebookConnected: false,
  lineConnected: false,
  passwordResetRequested: false,
  passwordResetEmail: null
};

// Check if user is already logged in from localStorage
try {
  const token = localStorage.getItem('ruaysure-auth-token');
  const user = JSON.parse(localStorage.getItem('ruaysure-user'));
  
  if (token && user) {
    initialState.isAuthenticated = true;
    initialState.user = user;
  }
} catch (error) {
  // If there's an error parsing the user from localStorage, keep the default state
  console.error('Error loading auth state from localStorage:', error);
}

// Auth reducer
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        error: null
      };
      
    case AUTH_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        facebookConnected: false,
        lineConnected: false
      };
      
    case AUTH_REGISTER:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        error: null
      };
      
    case AUTH_ERROR:
      return {
        ...state,
        error: action.payload
      };
      
    case AUTH_LOADING:
      return {
        ...state,
        loading: action.payload
      };
      
    case AUTH_RESET_PASSWORD:
      return {
        ...state,
        passwordResetRequested: true,
        passwordResetEmail: action.payload,
        error: null
      };
      
    case AUTH_CONNECT_FACEBOOK:
      return {
        ...state,
        facebookConnected: true,
        user: {
          ...state.user,
          facebookData: action.payload
        }
      };
      
    case AUTH_CONNECT_LINE:
      return {
        ...state,
        lineConnected: true,
        user: {
          ...state.user,
          lineData: action.payload
        }
      };
      
    default:
      return state;
  }
};

export default authReducer;
